<div class="closing-x-wrap">
    <mat-icon class="close-icon condenced" alt="Close dialog" (click)="close()"> close </mat-icon>
</div>
<h1 mat-dialog-title id="signature-title">Edit {{ data.deal.jacketTypeId === JacketType.Deal ? 'Deal' : 'Jacket' }} Information</h1>
<div mat-dialog-content>
    <form [formGroup]="jacketForm">
        <!-- Deals -->
        <ng-container *ngIf="data.deal.jacketTypeId === JacketType.Deal">
            <div class="row">
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Deal #</mat-label>
                    <input placeholder="Deal #" class="form-control" type="text" matInput formControlName="dealerDealNumber" />
                </mat-form-field>
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Deal Type Name</mat-label>
                    <input placeholder="Deal Type Name" class="form-control" type="text" matInput formControlName="dealTypeName" />
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Jacket ID</mat-label>
                    <input placeholder="DDJ Deal ID" class="form-control" type="text" matInput formControlName="dealId" />
                </mat-form-field>
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Created By</mat-label>
                    <input placeholder="Created By" class="form-control" type="text" matInput formControlName="createdBy" />
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field appearance="fill" class="col-6">
                    <mat-label>Finance Manager</mat-label>
                    <input
                        type="text"
                        matInput
                        formControlName="financeManager"
                        [matAutocomplete]="auto"
                        #autoCompleteTrigger="matAutocompleteTrigger"
                        placeholder="Search Finance Manager..."
                        (keydown.enter)="onEnter()"
                    />
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFinanceManager">
                        <mat-option *ngFor="let user of filteredFinanceManagers" [value]="user"> {{ user.firstName }} {{ user.lastName }} </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Deal Category</mat-label>
                    <input placeholder="Deal Category" class="form-control" type="text" matInput formControlName="jacketStatus" />
                </mat-form-field>
            </div>
            <div class="row" *ngIf="data.deal.statusId === JacketStatus.Deleted">
                <mat-form-field class="col-12" appearance="fill">
                    <mat-label>Reason for Deletion</mat-label>
                    <textarea placeholder="Reason for Deletion" class="form-control" matInput formControlName="deleteReason"></textarea>
                </mat-form-field>
            </div>
        </ng-container>

        <!-- Cons Documents -->
        <ng-container *ngIf="data.deal.jacketTypeId === JacketType.Document">
            <div class="row">
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Jacket ID</mat-label>
                    <input placeholder="Jacket ID" class="form-control" type="text" matInput formControlName="jacketId" />
                </mat-form-field>
                <mat-form-field class="col-6">
                    <mat-label>Jacket Type</mat-label>
                    <mat-select class="form-control" matInput formControlName="jacketType">
                        <mat-option *ngFor="let rfrStatus of ReasonForRequestStatuses" [value]="rfrStatus.value">
                            {{ rfrStatus.key }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Created By</mat-label>
                    <input placeholder="Created By" class="form-control" type="text" matInput formControlName="createdBy" />
                </mat-form-field>
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Jacket Category</mat-label>
                    <input placeholder="Jacket Category" class="form-control" type="text" matInput formControlName="jacketStatus" />
                </mat-form-field>
            </div>
            <div class="row">
                <div class="row" *ngIf="data.deal.statusId === JacketStatus.Deleted">
                    <mat-form-field class="col-12" appearance="fill">
                        <mat-label>Reason for Deletion</mat-label>
                        <textarea placeholder="Reason for Deletion" class="form-control" matInput formControlName="deleteReason"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <!-- Storage -->
        <ng-container *ngIf="data.deal.jacketTypeId === JacketType.Storage">
            <div class="row">
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Jacket ID</mat-label>
                    <input placeholder="Jacket ID" class="form-control" type="text" matInput formControlName="jacketId" />
                </mat-form-field>
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Deal #</mat-label>
                    <input placeholder="Deal #" class="form-control" type="text" matInput formControlName="dealerDealNumber" />
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Created By</mat-label>
                    <input placeholder="Created By" class="form-control" type="text" matInput formControlName="createdBy" />
                </mat-form-field>
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Jacket Category</mat-label>
                    <input placeholder="Jacket Category" class="form-control" type="text" matInput formControlName="jacketStatus" />
                </mat-form-field>
            </div>
            <div class="row" *ngIf="data.deal.statusId === JacketStatus.Deleted">
                <mat-form-field class="col-12" appearance="fill">
                    <mat-label>Reason for Deletion</mat-label>
                    <textarea placeholder="Reason for Deletion" class="form-control" matInput formControlName="deleteReason"></textarea>
                </mat-form-field>
            </div>
        </ng-container>
    </form>
</div>
<div mat-dialog-actions class="form-footer">
    <button mat-button class="secondary" (click)="close()">Cancel</button>
    <button mat-button class="primary" (click)="submitForm()">Save</button>
</div>
